/* eslint-disable import/prefer-default-export */
import {createAsyncThunk} from '@reduxjs/toolkit';
import fetchRequest from './utils';

export const getAllAppAwareTiers = createAsyncThunk('appAwareTiers/getAllAppAwareTiers', async () => fetchRequest('/app-aware-tiers', 'GET'));
